// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-N1":"N1_outdoor-recreation-N1__Ukn8C"};